/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wb_Management_Src_1_DetailInputs */

const en_wb_management_src_1_detail = /** @type {(inputs: Wb_Management_Src_1_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proposals awaiting review`)
};

const lv_wb_management_src_1_detail = /** @type {(inputs: Wb_Management_Src_1_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Piedāvājumi, kas gaida pārbaudi`)
};

/**
* | output |
* | --- |
* | "Proposals awaiting review" |
*
* @param {Wb_Management_Src_1_DetailInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const wb_management_src_1_detail = /** @type {((inputs?: Wb_Management_Src_1_DetailInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wb_Management_Src_1_DetailInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_wb_management_src_1_detail(inputs)
	return en_wb_management_src_1_detail(inputs)
});